import getApi from '../../api'
import { ActivePrinciple } from '../../model/Drug'

export const getActivePrinciples = (search: string, signal?: AbortSignal) =>
  getApi().get<Array<ActivePrinciple>>(`/drugs/active_principles`, { search }, { signal })
